import React from "react";
import { Box, Typography, Radio, TextField, Button } from "@mui/material";
import { Check as CheckIcon } from "@mui/icons-material";
import { ReviewDecisionStatus } from "../../../../../utils/enums";

const BulkActionBar = ({
  selectedCount,
  bulkDecision,
  bulkComment,
  onBulkDecisionChange,
  onBulkCommentChange,
  onSave,
}) => {
  return (
    <Box
      sx={{
        bgcolor: "#F3F4F6",
        p: 2,
        borderRadius: "8px",
        mb: 2,
        border: "1px solid #E5E7EB",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 3,
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {selectedCount} users selected
          </Typography>

          <Box sx={{ display: "flex", gap: 2 }}>
            <Radio
              checked={bulkDecision === ReviewDecisionStatus.APPROVED}
              onChange={() => onBulkDecisionChange(ReviewDecisionStatus.APPROVED)}
              sx={{
                p: 0,
                color: bulkDecision === ReviewDecisionStatus.APPROVED ? "#16A34A" : "#9CA3AF",
                "&.Mui-checked": {
                  color: "#16A34A",
                },
              }}
            />
            <Typography variant="body2" sx={{ mr: 2, alignSelf: "center" }}>
              Approve
            </Typography>

            <Radio
              checked={bulkDecision === ReviewDecisionStatus.MODIFIED}
              onChange={() => onBulkDecisionChange(ReviewDecisionStatus.MODIFIED)}
              sx={{
                p: 0,
                color: bulkDecision === ReviewDecisionStatus.MODIFIED ? "#F59E0B" : "#9CA3AF",
                "&.Mui-checked": {
                  color: "#F59E0B",
                },
              }}
            />
            <Typography variant="body2" sx={{ mr: 2, alignSelf: "center" }}>
              Modify
            </Typography>

            <Radio
              checked={bulkDecision === ReviewDecisionStatus.REJECTED}
              onChange={() => onBulkDecisionChange(ReviewDecisionStatus.REJECTED)}
              sx={{
                p: 0,
                color: bulkDecision === ReviewDecisionStatus.REJECTED ? "#DC2626" : "#9CA3AF",
                "&.Mui-checked": {
                  color: "#DC2626",
                },
              }}
            />
            <Typography variant="body2" sx={{ alignSelf: "center" }}>
              Revoke
            </Typography>
          </Box>
        </Box>

        <Button
          size="small"
          variant="contained"
          startIcon={<CheckIcon sx={{ fontSize: 16 }} />}
          onClick={onSave}
          disabled={!bulkDecision}
          sx={{
            backgroundColor: "#10B981",
            color: "white",
            fontWeight: 500,
            borderRadius: "6px",
            textTransform: "none",
            fontSize: "13px",
            px: 2,
            py: 0.75,
            "&:hover": {
              backgroundColor: "#059669",
            },
            "&:disabled": {
              backgroundColor: "#D1D5DB",
              color: "#9CA3AF",
            },
          }}
        >
          Save
        </Button>
      </Box>

      {(bulkDecision === ReviewDecisionStatus.MODIFIED || bulkDecision === ReviewDecisionStatus.REJECTED) && (
        <TextField
          size="small"
          placeholder={
            bulkDecision === ReviewDecisionStatus.MODIFIED
              ? "What's the new role and why?"
              : "Reason for revoking"
          }
          value={bulkComment}
          onChange={(e) => onBulkCommentChange(e.target.value)}
          fullWidth
          multiline
          rows={2}
          sx={{
            mt: 2,
            "& .MuiOutlinedInput-root": {
              fontSize: "0.875rem",
              bgcolor: "white",
            },
          }}
        />
      )}
    </Box>
  );
};

export default BulkActionBar;

